const actions = {
  GET_MENU: 'dropDown/GET_MENU',
  SET_MENU: 'drowDown/SET_MENU',
}

export default actions
